import cookie from "react-cookies";
import type { TFunction } from "i18next";

export const headerActions = {
  navigation: {
    myProfile: () => {
      window.location.href = "/profile";
    },

    clientProfile: () => {
      window.location.href = "/client-profile";
    },

    careTeam: () => {
      window.location.href = "/care-team";
    },

    dataPrivacy: () => {
      window.location.href = "/privacy-settings";
    },

    assessments: () => {
      window.location.href = "/assessments";
    },

    documents: () => {
      window.location.href = "/documents";
    },

    resetPassword: () => {
      window.location.href = "/change-password";
    },

    switchAccounts: () => {
      window.location.href = "/account-selector";
    },

    dashboard: () => {
      window.location.href = "/dashboard";
    },
  },

  external: {
    privacyPolicy: () => {
      window.open("https://www.getanswersnow.com/privacy", "_blank");
    },

    termsOfUse: () => {
      window.open("https://www.getanswersnow.com/terms", "_blank");
    },
  },
};

export const getClientId = (user: any): string | null => {
  if (!user?.id) return null;
  return cookie.load(`${user.id}-clientId`);
};

export const translateRelationship = (t: TFunction, value?: string | null): string => {
  if (!value) return "-";
  return t(`clientHeader:options.relationship.${value}`, { defaultValue: value });
};

export const translateLanguage = (t: TFunction, value?: string | null): string => {
  if (!value?.trim()) return "-";
  const normalized = value.trim().toLowerCase();
  return t(`clientHeader:options.language.${normalized}`, { defaultValue: value });
};

export const translatePronouns = (t: TFunction, value?: string | null): string => {
  if (!value?.trim()) return "-";
  return t(`clientHeader:options.pronouns.${value.trim().toLowerCase()}`, { defaultValue: value });
};

const DIAGNOSIS_CODE_PATTERN = /^([A-Z]\d+(?:\.\d+)?)\s+(.+)$/;

export const translateDiagnosis = (t: TFunction, value?: string | null): string => {
  if (!value?.trim()) return "-";
  const trimmed = value.trim();
  const match = trimmed.match(DIAGNOSIS_CODE_PATTERN);

  if (match) {
    const [, code, label] = match;
    const translatedLabel = t(`clientHeader:options.diagnosis.${label}`, { defaultValue: label });
    return `${code} ${translatedLabel}`;
  }

  return t(`clientHeader:options.diagnosis.${trimmed}`, { defaultValue: trimmed });
};

export const translateDocumentType = (t: TFunction, value?: string | null): string => {
  if (!value) return "-";
  return t(`clientHeader:options.documentType.${value}`, { defaultValue: value });
};

export const translateDocumentStatus = (t: TFunction, value?: string | null): string => {
  if (!value) return "-";
  return t(`clientHeader:options.documentStatus.${value}`, { defaultValue: value });
};

export const translateCountObjectDisplayNames = (
  t: TFunction,
  countObject: any,
  translateFn: (t: TFunction, value?: string | null) => string
): any => {
  if (!countObject) return countObject;
  if (!Array.isArray(countObject)) return countObject;
  return countObject.map((item: any) => ({ ...item, display_name: translateFn(t, item.display_name) }));
};

export const translateGender = (t: TFunction, value?: string | null): string => {
  if (!value) return "-";
  return t(`clientHeader:options.gender.${value}`, { defaultValue: value });
};

export const translateEthnicity = (t: TFunction, value?: string | null): string => {
  if (!value) return "-";
  return value
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean)
    .map((part) => t(`clientHeader:options.ethnicity.${part}`, { defaultValue: part }))
    .join(", ");
};
